import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Avatar } from '../fields/Avatar';
import { useUserService } from 'services';
import { RouteConstants } from '../../../constants';
import styles from './ProfileMenu.module.css';

export const ProfileMenu = () => {
  const { t } = useTranslation();
  const userService = useUserService();
  const navigate = useNavigate();

  const logout = () => {
    userService.logout();
  };

  const goToChangePassword = () => {
    navigate(RouteConstants.changePassword);
  };

  const getInitialsFromUsername = () => {
    const storedUser = localStorage.getItem('user');
    const username = storedUser ? JSON.parse(storedUser)?.username : null;

    if (!username) return 'U';

    const namePart = username.split('@')[0];

    const nameParts = namePart
      .replace(/[^a-zA-Z]/g, ' ')
      .split(' ')
      .filter(Boolean);

    if (nameParts.length >= 2) {
      return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
    } else if (nameParts.length === 1) {
      return nameParts[0].slice(0, 2).toUpperCase();
    } else {
      return 'U';
    }
  };

  return (
    <div className={`dropdown ${styles.profileContainer}`}>
      <div
        className={`d-flex align-items-center ${styles.avatarWrapper}`}
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Avatar initials={getInitialsFromUsername()} variant="small" />
      </div>

      <ul className={`dropdown-menu dropdown-menu-end ${styles.dropdownMenu}`}>
        <li>
          <button className={`dropdown-item ${styles.menuItem}`} onClick={goToChangePassword}>
            {t('AUTH.CHANGE_PASSWORD')}
          </button>
        </li>
        <li>
          <button className={`dropdown-item ${styles.menuItem}`} onClick={logout}>
            {t('AUTH.LOGOUT')}
          </button>
        </li>
      </ul>
    </div>
  );
};
